import * as types from "../actions/ActionTypes";
// import _ from "lodash";

const defaultState = {
  countries: [],
  followers:[],
  contents:[],
  isContentsLoading:false,
  isRequesting: false,
  user: {
    profile: {},
  },
  communityFilter: '',
  profilePatchPending: false,
  profilePatchFulfilled: false,
  profilePatchError: {},

  followedCategories: [],
  followedCategoriesRequested: false,
  followedCategoriesPosted: false,
  followedCategoriesError: {},
  error: "",

  seed: {},
  seedPosting: false,
  seedPosted: false,
  seedPostError: {},

  balanceGetting: false,
  balanceGot: false,
  balance: {
    amount: 0,
    prevAmount: 0,
  },
  balanceGetError: {},

  contentPurchasedPending: false,
  contentPurchased: [],
  contentPurchasedError: {},

  contentSeededPending: false,
  contentSeeded: [],
  contentSeededError: {},

  walletPending: false,
  wallet: "",
  walletError: {},

  walletPostPending: false,
  walletPostFulfilled: false,
  walletPostError: {},

  contentStatusPending: false,
  contentStatusFulfilled: {},
  contentStatusError: {},

  allowExitUpload: true,

  series: [],
  getSeriesPending: false,
  getSeriesError: {},
  userStats: null
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.USER_ME_PENDING:
      return {
        ...state,
        isRequesting: true,
      };
    case types.USER_ME_FULFILLED:
      let communityFilter =
        state.communityFilter !== undefined && state.communityFilter !== ""
          ? state.communityFilter
          : "community";
      return Object.assign({}, state, {
        isRequesting: false,
        user: action.payload,
        communityFilter: communityFilter,
        error: "",
      });
    case types.USER_ME_REJECTED:
      return Object.assign({}, state, {
        isRequesting: false,
        error: "",
      });

    case types.USER_BALANCE_PENDING:
      return Object.assign({}, state, {
        balanceGetting: true,
      });
    case types.USER_BALANCE_FULFILLED:
      return Object.assign({}, state, {
        balanceGetting: false,
        balanceGot: true,
        balance: { ...action.payload, prevAmount: action.payload.amount },
      });
    case types.USER_BALANCE_REJECTED:
      return Object.assign({}, state, {
        balanceGetting: false,
        balanceGetError: action.payload.response,
      });

    case types.USER_PROFILE_PATCH_PENDING:
      return Object.assign({}, state, {
        profilePatchPending: true,
      });
    case types.USER_PROFILE_PATCH_FULFILLED:
      return Object.assign({}, state, {
        profilePatchPending: false,
        profilePatchFulfilled: true,
        user: action.payload,
      });
    case types.USER_PROFILE_PATCH_REJECTED:
      return Object.assign({}, state, {
        profilePatchPending: false,
        profilePatchError: action.payload.response,
      });

    case types.FOLLOWED_CATEGORIES_PENDING:
      return Object.assign({}, state, {
        isRequesting: true,
        error: "",
      });
    case types.FOLLOWED_CATEGORIES_FULFILLED:
      return Object.assign({}, state, {
        isRequesting: false,
        followedCategories: action.payload,
        followedCategoriesRequested: true,
        error: "",
      });
    case types.FOLLOWED_CATEGORIES_REJECTED:
      return Object.assign({}, state, {
        isRequesting: false,
        followedCategories: [],
        followedCategoriesRequested: false,
        error: action.payload,
      });

    case types.FOLLOWED_CATEGORIES_POST_PENDING:
      return Object.assign({}, state, {
        isRequesting: true,
        followedCategoriesPosted: false,
        error: "",
      });
    case types.FOLLOWED_CATEGORIES_POST_FULFILLED:
      return Object.assign({}, state, {
        isRequesting: false,
        followedCategories: action.payload,
        followedCategoriesPosted: true,
        error: "",
      });
    case types.FOLLOWED_CATEGORIES_POST_REJECTED:
      return Object.assign({}, state, {
        isRequesting: false,
        followedCategoriesError: action.payload.response,
      });

    case types.USER_SEED_POST_PENDING:
      return Object.assign({}, state, {
        seedPosting: true,
      });
    case types.USER_SEED_POST_FULFILLED:
      return Object.assign({}, state, {
        seedPosting: false,
        seedPosted: true,
      });
    case types.USER_SEED_POST_REJECTED:
      return Object.assign({}, state, {
        seedPosting: false,
        seedPostError: action.payload,
      });

    case types.USER_CONTENT_PURCHASED_PENDING:
      return Object.assign({}, state, {
        contentPurchasedPending: true,
      });
    case types.USER_CONTENT_PURCHASED_FULFILLED:
      // let localData = _.filter(
        // state.contentPurchased,
        // (cp) => _.findIndex(action.payload, (ap) => ap.uuid === cp.uuid) === -1
      // );
      // let contentPurchased = [...action.payload, ...localData];
      return Object.assign({}, state, {
        contentPurchasedPending: false,
        // contentPurchased: contentPurchased,
      });
    case types.USER_CONTENT_PURCHASED_REJECTED:
      return Object.assign({}, state, {
        contentPurchasedPending: false,
        contentPurchasedError: action.payload.response,
      });

    case types.USER_CONTENT_SEEDED_PENDING:
      return Object.assign({}, state, {
        contentSeededPending: true,
      });
    case types.USER_CONTENT_SEEDED_FULFILLED:
      return Object.assign({}, state, {
        contentSeededPending: false,
        contentSeeded: action.payload,
      });
    case types.USER_CONTENT_SEEDED_REJECTED:
      return Object.assign({}, state, {
        contentSeededPending: false,
        contentSeededError: action.payload.response,
      });

    case types.USER_WALLET_PENDING:
      return Object.assign({}, state, {
        walletPending: true,
      });
    case types.USER_WALLET_FULFILLED:
      return Object.assign({}, state, {
        walletPending: false,
        wallet: action.payload,
      });
    case types.USER_WALLET_REJECTED:
      return Object.assign({}, state, {
        walletPending: false,
        walletError: action.payload.response,
      });

    case types.USER_WALLET_POST_PENDING:
      return Object.assign({}, state, {
        walletPostPending: true,
      });
    case types.USER_WALLET_POST_FULFILLED:
      return Object.assign({}, state, {
        walletPostPending: false,
        wallet: action.payload,
        walletPostFulfilled: true,
      });
    case types.USER_WALLET_POST_REJECTED:
      return Object.assign({}, state, {
        walletPostPending: false,
        walletPostError: action.payload.response,
      });

    case types.USER_CONTENTS_STATUS_PENDING:
      return Object.assign({}, state, {
        contentStatusPending: true,
      });
    case types.USER_CONTENTS_STATUS_FULFILLED:
      return Object.assign({}, state, {
        contentStatusPending: false,
        // contentStatusFulfilled: { id: _.uniqueId() },
      });
    case types.USER_CONTENTS_STATUS_REJECTED:
      return Object.assign({}, state, {
        contentStatusPending: false,
        // contentStatusError: { ...action.payload.response, id: _.uniqueId() },
      });
    case types.USER_SERIES_GET_PENDING:
      return Object.assign({}, state, {
        getSeriesPending: true,
      });
    case types.USER_SERIES_GET_FULFILLED:
      return Object.assign({}, state, {
        getSeriesPending: false,
        series: action.payload,
      });
    case types.USER_SERIES_GET_REJECTED:
      return Object.assign({}, state, {
        getSeriesPending: false,
        getSeriesError: action.payload.response,
      });

    case types.USER_SEED_SAVE:
      return Object.assign({}, state, {
        seed: action.payload,
      });
    case types.TOGGLE_ALLOW_EXIT_UPLOAD:
      return Object.assign({}, state, {
        allowExitUpload: action.payload,
      });
    case types.AD_POST_FULFILLED:
      return {
        ...state,
        balance: {
          ...state.balance,
          prevAmount: state.balance.amount,
          amount: action.payload.newBalance,
        },
      };
    case types.USER_RESET:
      return defaultState;
    case types.CHANGE_COMMUNITY_FILTER:
      return Object.assign({}, state, {
        communityFilter: action.payload,
      });
    case types.UPDATE_LOCAL_PURCHASED:
      state.contentPurchased.push({
        uuid: action.payload,
        purchaseDate: new Date(),
      });
      return state;
    case types.USER_CONTENTS_ALL_PENDING:
      return {
        ...state,
        isContentsLoading: true
    }
    case types.USER_CONTENTS_ALL_FULFILLED:
      return {
        ...state,
        isContentsLoading: false,
        contents:action.payload
    }
    case types.FOLLOWERS_REJECTED:
      return {
        ...state,
        followers: [],
    }
    case types.FOLLOWERS_PENDING:
      return {
        ...state,
        followers: [],
    }
    case types.FOLLOWERS_FULFILLED:
      return {
        ...state,
        followers: action.payload,
    }
    case types.COUNTRIES_REJECTED:
      return {
        ...state,
        countries: [],
    }
    case types.COUNTRIES_PENDING:
      return {
        ...state,
        countries: [],
    }
    case types.COUNTRIES_FULFILLED:
      return {
        ...state,
        countries: action.payload,
    }
    case types.GET_STATS_REJECTED:
      return {
        ...state
      }

      case types.GET_STATS_PENDING:
      return {
        ...state
      }

      case types.GET_STATS_FULFILLED:
      return {
        ...state,
        userStats: action.payload
      }
    case "LOGOUT":
      return defaultState;
    default:
      return state;
  }
}
